// Stub for server-only packages transitively imported by workspace packages.
// These are dead code in the browser bundle (tree-shaken away).
export default {};
